import React from "react";
import { connect } from "react-redux";
import { Popup, Button, NavBar, Tabs } from "devextreme-react";
import {
  openCloseModalEditarRoles,
  setSelectedTab,
  setSelectedTrabajador,
  doUpdateUserRoles,
  setLoadingResumeData,
  openCloseSelectRoles,
  openCloseSelectGrupos,
  doGetUserPortalEmpresa,
  loading,
} from "./actions";
import SelectField from "../../../../Shared/fields/SelectField";

import TextField from "../../../../Shared/fields/TextField";
import constants from "../../../../../helpers/constants";
import validaciones from "../../../../../helpers/validaciones";
import SelectRoles from "./selectRoles";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { roleTypes, workerPermits } from "../../../../../helpers/constants";
import { getAllRolesByAchsAction } from "components/SucursalVirtual/Mantenedores/TrabajadoresACHS/action";

let currentUserRoles;

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

const calcState = (obj, props) => {
  const { companyId, myCompanyProfiles, myCompanyRoles, allRoles } = props;
    // let allRolesCp = [ ...allRoles ];

    myCompanyProfiles[companyId] = myCompanyProfiles[companyId] ?? [];

    // console.log(">>>>>>>>>>>>>>>>>>>", companyId, myCompanyProfiles[companyId]);
    // const rttyp = roleTypes.filter(rt => props.userProfiles.includes(rt.Code));
    let rttyp = roleTypes.filter(rt => myCompanyProfiles[companyId].includes(rt.Code)) ?? [];

    const isAdmin = myCompanyRoles[companyId]?.includes('Admin') || myCompanyRoles[companyId]?.includes('Contact Center');
    const isContactCenter = myCompanyRoles[companyId]?.includes('Contact Center');
    const isAdminSEL = myCompanyRoles[companyId]?.includes('Administrador SEL')
    const isSoporteSEL = myCompanyRoles[companyId]?.includes('Soporte SEL')
    const isSolicitanteSEL = myCompanyRoles[companyId]?.includes('Solicitante SEL')
    const isFull = myCompanyRoles[companyId]?.includes('Full');
    const hasTrabajadorProfile = !!rttyp.find(r => r.Code === 'PER_TRABAJADOR');
    //NOTE: REVISAR ULTIMO CODIGO -> && (isFull && !isAdminSEL)
    const hasEmpresaProfile = !!rttyp.find(r => r.Code === 'PER_EMPRESA') && (isFull && !isAdminSEL);
    const isOtherSEL = myCompanyProfiles[companyId]?.some(element => element.indexOf('SEL') > -1);

    try {
      if(isAdmin && !hasTrabajadorProfile)
       {
         if(!rttyp.some(element => element.Code === 'PER_TRABAJADOR')) {
           rttyp.push(roleTypes.find(r => r.Code === 'PER_TRABAJADOR'));
         }
       }

       if(isAdmin && !hasEmpresaProfile)
       {
        if(!rttyp.some(element => element.Code === 'PER_EMPRESA')) {
          rttyp.push(roleTypes.find(r => r.Code === 'PER_EMPRESA'));
        }
       }

       if (!isAdmin)
       {
         for(let r of rttyp)
           if(r.Code === 'PER_TRABAJADOR')
             {
               const indexToRemove = rttyp.indexOf(r);

               rttyp = [...rttyp.slice(0, indexToRemove), ...rttyp.slice(indexToRemove + 1)]
             }
       }

      //  if(isSoporteSEL && !isAdminSEL)
      //   for(let ra of allRolesCp)
      //     if(ra.Name === 'Administrador SEL')
      //       {
      //         const indexToRemove = allRolesCp.indexOf(ra);

      //         allRolesCp = [...allRolesCp.slice(0, indexToRemove), ...allRolesCp.slice(indexToRemove + 1)]
      //       }

      // if((!isSoporteSEL && !isAdminSEL) && (!isContactCenter && !isAdmin && !isSolicitanteSEL && !isOtherSEL)) //ultima condicion caso empresa/trabajador/SEL // || (isContactCenter && isAdminSEL && isFull))
      if(!isSoporteSEL && !isAdminSEL) //ultima condicion caso empresa/trabajador/SEL // || (isContactCenter && isAdminSEL && isFull))
      for(let r of rttyp)
        if(r.Code === 'PER_SEL')
        {
          const indexToRemove = rttyp.indexOf(r);

          rttyp = [...rttyp.slice(0, indexToRemove), ...rttyp.slice(indexToRemove + 1)]
        }

        //NOTE: REVISAR ULTIMO CODIGO
        //NOTE no entendí la nota de arriba, aunque la dejé yo mismo :v
        if(!isAdminSEL && isFull && !isAdmin)
          for(let r of rttyp)
            if(r.Code === 'PER_EMPRESA')
            {
              const indexToRemove = rttyp.indexOf(r);

              rttyp = [...rttyp.slice(0, indexToRemove), ...rttyp.slice(indexToRemove + 1)]
            }

        if((isAdminSEL || isSoporteSEL) && !(isAdmin || isContactCenter))
        for(let r of rttyp)
          if(r.Code === 'PER_EMPRESA')
          {
            const indexToRemove = rttyp.indexOf(r);

            rttyp = [...rttyp.slice(0, indexToRemove), ...rttyp.slice(indexToRemove + 1)]
          }
    } catch (err) {
        // TODO: remake this sh*t
        console.log("*** err");
    }

    obj.state = {
      roleType: rttyp && rttyp.length > 0 ? rttyp[0].Id : 0,
      permissions: null,
      roleTypes: rttyp,
      // allRoles: allRolesCp,
      // userRoles: [...props.roles]
    };
}

const getRolesCalc = (props) => {
  const { companyId, myCompanyRoles, allRoles } = props;
    let allRolesCp = [ ...allRoles ];

    const isAdminSEL = myCompanyRoles[companyId]?.includes('Administrador SEL');
    const isSoporteSEL = myCompanyRoles[companyId]?.includes('Soporte SEL');

    try {
       if(isSoporteSEL && !isAdminSEL)
        for(let ra of allRolesCp)
          if(ra.Name === 'Administrador SEL')
            {
              const indexToRemove = allRolesCp.indexOf(ra);

              allRolesCp = [...allRolesCp.slice(0, indexToRemove), ...allRolesCp.slice(indexToRemove + 1)]
            }

    } catch (err) {
        // TODO: remake this sh*t
        console.log("**** err");
    }

    return allRolesCp ?? [];
}

class ModalEditarRoles extends React.PureComponent {
  constructor(props) {
    super(props);

    calcState(this, props);
  }

  componentWillUnmount = () => {
    this.props.dispatch(openCloseSelectRoles(false));
  };

  handleCerrar = () => {
    this.props.dispatch(openCloseModalEditarRoles(false, {}));
    this.props.dispatch(setLoadingResumeData({}));
    this.props.dispatch(setSelectedTab(this.props.sectionTabs[0]));
    this.props.dispatch(loading(false));
  };


  handleAsignar = () => {
      let trabajador = this.props.selectedTrabajador;
      let originalPermissions =
        trabajador && trabajador.Roles && trabajador.Roles.find((r) => r.Id === 6)
          ? 6
          : trabajador &&
            trabajador.Roles &&
            trabajador.Roles.find((r) => r.Id === 8)
          ? 8
          : null;
      let defPermissions = this.state.permissions || originalPermissions;
      // let permissionsRol =
      //   defPermissions &&
      //   this.props.allRoles.find((rol) => rol.Id === parseInt(defPermissions))
      //     ? [
      //         this.props.allRoles.find(
      //           (rol) => rol.Id === parseInt(defPermissions)
      //         ),
      //       ]
      //     : [];
      // trabajador.Roles = trabajador.Roles.filter(
      //   (r) => r.Id !== 6 && r.Id !== 8
      // ).concat(permissionsRol);

      trabajador.Relation = defPermissions === 6 ? "Interno": "Externo";
      trabajador.RelationTypeCode = defPermissions === 6 ? "INT": "EXT";
      if (trabajador.Relation !== this.props.selectedTrabajador) {
        trabajador.edited = true;
      }
      const selectedRoles = trabajador.Roles.map(i => i.Id);
      const current = currentUserRoles.map(i => i.Id);
      const newRoles = this.props.allRoles
        .filter(i => current.includes(i.Id))
        .filter(i => (this.state.roleType !== i.IdProfile) && !selectedRoles.includes(i.Id))
        .map(i => i.Id).filter(onlyUnique);
      const shld = [...selectedRoles, ...newRoles
      ];
      const newRolesTrab = {
        ...trabajador,
        Roles: this.props.allRoles.filter(i => shld.includes(i.Id))
      }

      const rolInExt = this.props.allRoles.find(i => i.Id === this.state.permissions);
      if(rolInExt) {
        const newTrab2 = newRolesTrab.Roles.filter(i => i.Id !== 6 && i.Id !== 8 );
        newTrab2.push(rolInExt);
        newRolesTrab.Roles = newTrab2;
      }

      this.props.dispatch(doUpdateUserRoles(newRolesTrab, this.props.companyId));
  };

  handleRoles = (e) => {
    const newData = { ...this.props.selectedTrabajador };
    let originalPermissions =
      newData && newData.Roles && newData.Roles.find((r) => r.Id === 6)
        ? 6
        : newData && newData.Roles && newData.Roles.find((r) => r.Id === 8)
        ? 8
        : null;

    let defPermissions = this.state.permissions || originalPermissions;
    let permissionsRol =
      defPermissions &&
      this.props.allRoles.find((rol) => rol.Id === parseInt(defPermissions))
        ? [
            this.props.allRoles.find(
              (rol) => rol.Id === parseInt(defPermissions)
            ),
          ]
        : [];
    newData.Roles = newData.Roles.filter(
      (r) => r.Id !== 6 && r.Id !== 8
    ).concat(permissionsRol);

    const newRoles =
      e.value === []
        ? []
        : e.value.map((itemId) =>
            this.props.allRoles.find((i) => i.Id === itemId)
          );
    newData.Roles = newRoles;
    newData.Roles = newData.Roles.filter(
      (r) => r.Id !== 6 && r.Id !== 8
    ).concat(permissionsRol);
    newData.edited = true;
    this.props.dispatch(setSelectedTrabajador(newData));
  };

  handleTypeChange = (event) => {
    this.setState({
      roleType: event.value,
      permissions: event.value === 1 ? null : this.state.permissions,
    });
  };

  handlePermissionsChange = (event) => {
    this.setState({
      permissions: event.value,
    });
  };

  render() {
    let workerPermitsEdited = [];
    workerPermits.forEach((item) => {
      workerPermitsEdited.push({
        Id: item.Id,
        Name: `${item.Name + ": " + item.Description}`,
      });
    });
    currentUserRoles =
      this.props.selectedTrabajador.Roles === undefined
      ? undefined
      : (currentUserRoles ?? this.props.selectedTrabajador.Roles);

    let trabajador = this.props.selectedTrabajador;
    let originalPermissions =
      trabajador && trabajador.Roles && trabajador.Roles.find((r) => r.Id === 6)
        ? 6
        : trabajador &&
          trabajador.Roles &&
          trabajador.Roles.find((r) => r.Id === 8)
        ? 8
        : null;

    return (
      <Popup
        visible={this.props.isOpenModalEditarRoles}
        onHiding={this.handleCerrar}
        dragEnabled={false}
        height={550}
        width={600}
        title="Roles trabajador"
        showCloseButton
        contentComponent={() => (
          <div>
            <div
              style={{
                position: "absolute",
                left: 20,
                right: 20,
                marginTop: -10,
              }}
            >
              {this.props.isLoading && <LoadingOverlay />}
              <TextField
                label="Trabajador"
                disabled
                value={this.props.selectedTrabajador.EmployeeName}
              />
              <TextField
                label="Rut"
                disabled
                value={this.props.selectedTrabajador.Rut}
              />
              <SelectField
                label="Tipo de rol"
                onChange={this.handleTypeChange}
                items={this.state.roleTypes}
                defaultValue={this.state.roleType}
                required
                valueExpr="Id"
                displayExpr="Name"
              />
              {this.state.roleType === 2 ? (
                <SelectField
                  label="Permisos"
                  onChange={this.handlePermissionsChange}
                  items={workerPermitsEdited}
                  required
                  valueExpr="Id"
                  displayExpr="Name"
                  defaultValue={this.state.permissions || originalPermissions}
                />
              ) : (
                <SelectRoles
                  title="Roles"
                  selectedItems={
                    (this.props.selectedTrabajador.Roles &&
                      this.props.selectedTrabajador.Roles.map((r) => r.Id)) ||
                    []
                  }
                  // dataSource={this.props.allRoles.filter(r => r.IdProfile === this.state.roleType)}
                  dataSource={getRolesCalc(this.props).filter(r => r.IdProfile === this.state.roleType)}
                  onSelection={this.handleRoles}
                  openClose={(isOpen) =>
                    this.props.dispatch(openCloseSelectRoles(isOpen))
                  }
                  open={this.props.isOpenSelectRoles}
                />
              )}
            </div>
            <div className="button-row">
              <div>
                <Button text="Cancelar" onClick={this.handleCerrar} />
              </div>
              <div>
                <Button
                  text="Guardar"
                  type="success"
                  onClick={this.handleAsignar}
                />
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.global.userData,
  companyId: state.global.companyId?.toLowerCase(),
  roles: state.asignacionRoles.roles,
  isOpenModalEditarRoles: state.asignacionRoles.isOpenModalEditarRoles,
  selectedTrabajador: state.asignacionRoles.selectedTrabajador,
  isLoading: state.asignacionRoles.isLoading,
  sectionTabs: state.asignacionRoles.sectionTabs,
  selectedTab: state.asignacionRoles.selectedTab,
  gruposPortalEmpresa: state.asignacionRoles.gruposPortalEmpresa,
  isOpenSelectRoles: state.asignacionRoles.isOpenSelectRoles,
  allRoles: state.mantenedores.roles,
  userProfiles: state.global.userProfiles,
  myCompanyRoles: state.global.myCompanyRoles,
  myCompanyProfiles: state.global.myCompanyProfiles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditarRoles);
